import BIForm from './form/form';

let ContactUsForm = new BIForm({
    form_id: `#contactUs`
});

ContactUsForm.addSubmitListener(() => {
    window.location.reload();
});

// For every contact us button add click event
$(".contact-btn").click(function(e) {
    e.preventDefault();
    let contactBtns = $(".contact-btn").toArray();
    let btnIndex = contactBtns.indexOf(this);
    $($(".modal.contact-us")[btnIndex]).addClass("active");
});

// Close modal buttons
$(".close-modal-btn").click(function(e) {
    e.preventDefault();
    let modal = $($(this).closest(".modal.contact-us"));
    modal.find(".success").hide();
    modal.find(".failure").hide();
    modal.removeClass("active");
});

// Submit form
$(".contact-submit-btn").on('click', function(e) {
    e.preventDefault();
    let form = $($(this).closest('.contact-us-form'));
    let action = form.data('action')
    let firstName = form.find('input[name=firstName]').val();
    let lastName = form.find('input[name=lastName]').val();
    let email = form.find('input[name=email]').val();
    let message = form.find('textarea[name=message]').val();
    let successMsg = form.find(".success");
    let failureMsg = form.find(".failure");
    let submitBtn = form.find(".contact-submit-btn");
    submitBtn.addClass('disabled');
    var data =
    {
        'action':action,
        'firstName':firstName,
        'lastName':lastName,
        'email':email,
        'message':message
    }
    axios
    .post('/sendContactUsEmail',  data)
    .then(function (response) {
        failureMsg.hide();
        successMsg.css({ display: "inline-block" });
        submitBtn.removeClass('disabled');
        form[0].reset();
        })
        .catch(function (error) {
        successMsg.hide();
        failureMsg.css({ display: "inline-block" });
        submitBtn.removeClass('disabled');
    });
});
